module.exports = __webpack_public_path__ + "static/media/cover-greece.386c97ba.jpg";